import store from "@/modules/julho_14/store";
import routes from "@/modules/julho_14/routes";

export default {
  install(Vue, { store: rootStore, router }) {
    router.addRoutes(routes);
    rootStore.registerModule("julho_14", store);
  }
};
